//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
import axios from 'axios'
export default {
  name: 'relatorio',
  components: {
    GChart
  },
  data: () => {
    return {
      chartOptions: {
        width: '100%',
        legend: { position: 'top' },
        axes: {
          x: {
            0: { side: 'top', label: 'Tipos' }
          }
        },
        bar: { groupWidth: '40%' },
        colors: ['#EA4335', '#34A853', '#4285f4', '#ADB3BA']
      },
      error: false
    }
  },
  methods: {
    disparaServidor () {
      const page = document.getElementById('relatorio').outerHTML
      axios.post('api/email.php', {
        pagina: `
          <!DOCTYPE html>
          <html lang="pt-br>
            <head>
              <meta charset="utf-8">
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <meta name="viewport" content="width=device-width,initial-scale=1.0">
              <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons" rel="stylesheet" type="text/css">
              <link href="https://cdn.jsdelivr.net/npm/quasar@^1.0.0/dist/quasar.min.css" rel="stylesheet" type="text/css">
            </head>
            <body>${page}</body>
          </html>
        `,
        formulario: this.formulario,
        resultado: this.resultado
      })
        .then((res) => {
          // eslint-disable-next-line
          console.log(res.data)
          // if (res.data.success) {
          //   this.error = false
          // } else {
          //   this.error = true
          //   localStorage.removeItem('formulario')
          //   localStorage.setItem('inicio', false)
          // }
          // this.loading = false
        })
        .catch(() => {
          // this.loading = false
          // this.error = true
          // localStorage.removeItem('formulario')
          // localStorage.setItem('inicio', false)
        })
    }
  },
  computed: {
    ...mapGetters([
      'resultado',
      'definicoesPalavras',
      'personalidades',
      'formulario'
    ]),
    chartData () {
      return [
        ['Resultados', 'Sanguíneo', 'Colérico', 'Melancólico', 'Fleumático'],
        ['', this.resultado[0], this.resultado[1], this.resultado[2], this.resultado[3]]
      ]
    },
    returnTipo () {
      let max = Math.max(this.resultado[0], this.resultado[1], this.resultado[2], this.resultado[3])
      if (max === this.resultado[0]) {
        return 'A Personalidade do Popular Sanguíneo. O Extrovertido, o Falador, o Otimista'
      }
      if (max === this.resultado[1]) {
        return 'A Personalidade do Forte Colérico. O Extrovertido, o Fazedor, o Otimista'
      }
      if (max === this.resultado[2]) {
        return 'A Personalidade do Perfeito Melancólico. O Introvertido, o Pensador, o Pessimista'
      }
      if (max === this.resultado[3]) {
        return 'A Personalidade do Sereno Fleugmático. O Introvertïdo, o Observador, o Pessimista'
      }
      return ''
    }
  },
  mounted () {
    this.disparaServidor()
    setTimeout(() => {
      localStorage.setItem('inicio', false)
      localStorage.removeItem('formulario')
    }, 300000)
  },
  created () {
    this.$store.commit('formulario', JSON.parse(localStorage['formulario']))
  }
}
